import { api, ApiError } from '../api.js';
import { bindSubmit, field, setStatus, statusZone } from '../components/form.js';

const STATUS_ID = 'forgot-status';

export function renderForgotPassword(root) {
  root.innerHTML = `
    <div class="appbar">
      <a href="/login" data-link class="appbar-back" aria-label="Back">‹</a>
      <div class="appbar-title">Forgot password</div>
    </div>

    <div class="pad">
      <p class="lede-muted">
        Enter your email and we'll send you a reset link. The response is the same whether
        or not an account exists — that's by design.
      </p>

      <form id="forgot-form" class="form card" novalidate>
        ${field({ name: 'email', label: 'Email', type: 'email', autocomplete: 'email', placeholder: 'you@example.com' })}
        ${statusZone(STATUS_ID)}
        <button type="submit" class="btn">Send reset link</button>
      </form>

      <div class="center" style="margin-top:14px;font-size:12.5px;">
        <a href="/login" data-link>Back to log in</a>
      </div>
    </div>
  `;

  const form = document.getElementById('forgot-form');
  bindSubmit(form, async (data) => {
    setStatus(STATUS_ID, { message: 'Sending…', kind: 'info' });
    try {
      await api('/auth/password/forgot', {
        method: 'POST',
        body: { email: data.email },
      });
      setStatus(STATUS_ID, {
        message: 'If an account exists for that email, a reset link is on its way.',
        kind: 'success',
      });
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : 'Could not send reset email.';
      setStatus(STATUS_ID, { message: msg, kind: 'error' });
    }
  });
}
